import styled from "styled-components";

import Content from "components/Content";

const ContentAd = styled(Content)`
  width: 600px;
  text-align: center;
  height: 100%;
  max-width: 600px;
  color: #333333;

  @media (max-width: 420px) {
    width: 100%;
    height: 100%;
  }
`;

export default ContentAd;